import React from 'react'

import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  fill: {
    fill: theme.palette.primary.main
  },
  paper: {
    fill: '#fff',
    stroke: theme.palette.primary.main,
    strokeWidth: 5
  }
}))

export default function GalleryThumbnail({ ...props }) {
  const classes = useStyles(props)

  return (
    <svg viewBox="0 0 150 200">
      <rect x={15} y={65} width={25} height={25} className={classes.fill} />
      <rect x={45} y={65} width={25} height={25} className={classes.fill} />
      <rect x={75} y={65} width={25} height={25} className={classes.fill} />
      <rect x={105} y={65} width={25} height={25} className={classes.fill} />

      <rect x={15} y={115} width={25} height={25} className={classes.fill} />
      <rect x={45} y={115} width={25} height={25} className={classes.fill} />
      <rect x={75} y={115} width={25} height={25} className={classes.fill} />
      <rect x={105} y={115} width={25} height={25} className={classes.fill} />
    </svg>
  )
}
